import { Component, OnInit } from '@angular/core';
import { ProductService, SeoService } from '../../_services';
import { AppState } from '../../app.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PortalLinkDialogComponent } from './portal-link-dialog.component';
import { URLService } from 'src/app/_services/url/url.service';
import {AppConfig} from '../../_services/config/app-config';
@Component({
    selector: 'pq-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./_portal.component.scss'],
    standalone: false
})
export class PortalComponent implements OnInit {
  public loading: boolean = true;
  public error: boolean = false;
  public msg: string = this._appState.get('portalError');
  public productDisabledMessage: string = this._appState.get('portalProQuestAccountError');
  public proquestAccountDisabled: boolean = false;
  private _products: object[] = [];
  alexanderStreet: string = "View all video collections on Alexander Street"

  constructor (
    private _seoSvc: SeoService,
    private _appState: AppState,
    private _dialog: MatDialog,
    private _location: Location,
    private _productService: ProductService,
    private _urlService: URLService
  ) {
    this._seoSvc.setTitle('Homework Central ®');
    const isPortalInPath = this._location.path().indexOf('portal') !== -1;
    if (!isPortalInPath && Array.isArray(this._appState.get('allProducts')) && this._appState.get('allProducts').length <= 1) {
      this._location.replaceState('/portal/home');
    }
  }

  public ngOnInit(): void {
    const allProducts = this._appState.get('allProducts') || [];
    const culturegramProduct = allProducts.find(product => product.profile === 'culturegrams');
    const searchParams = new URLSearchParams(this._urlService.getSharedURL());
    const cgAppFlag = searchParams.get('app') === 'CG';
    const cgAppUsageModuleFlag = searchParams.get('app') === 'USAGE';
    if (culturegramProduct && (this.isNonCGTileMissing(allProducts) || cgAppFlag || cgAppUsageModuleFlag)) {
      this._productService.getProductUrl('culturegrams', 'proquest').subscribe((response: any) => {
        this.loading = true;
        console.log('response:', response);
        let url = response['ProductUrlResponse']['url'];
            if (url && cgAppUsageModuleFlag) {
              window.open(this.appendUsageStats(url), '_self');
            }else if (url) {
              window.open(url, '_self');
            }
      });
    }
    else if(allProducts.length >=1){
      this.error = allProducts.length === 0;
      this.loading = false;
      if (!this.error) {
        this._products = allProducts;

        if (this._products.length) {
          this.proquestAccountDisabled = this._products.filter((product) => {
            return product['name'] === 'ProQuest' && product['accessAllowed'] === 'false';
          }).length > 0;

          this._products = this._products.filter((product) => {
            return product['accessAllowed'] !== 'false';
          });
        }

      }
     } else {
        this.msg = this._appState.get('portalNoProductsError');
      }
    }

    public appendUsageStats(url: string): string {
      const pqtokenIndex = url.indexOf('?pqtoken');
      if (pqtokenIndex !== -1) {
        const baseURL = url.substring(0, pqtokenIndex);
        const queryParams = url.substring(pqtokenIndex);
        return `${baseURL}/usagestats${queryParams}`;
      }
      return url;
    }

  public handleProductLink (profile: string, e: Event): void {
    e.preventDefault();

    const product = this._products.filter((product) => {
      return product['profile']  === profile;
    })[0];

    if (product) {
      this._dialog.open(PortalLinkDialogComponent, {
        disableClose: true,
        panelClass: 'portal-link-dialog',
        width: '352px',
        maxWidth: 'calc(100vw - 32px)',
        data: {
          profile: product['profile'],
          platform: product['platform']
        }
      });
    }
  }

  public handleAlexanderStreetLink ( e: Event): void {
    e.preventDefault();


    this._dialog.open(PortalLinkDialogComponent, {
      disableClose: true,
      panelClass: 'portal-link-dialog',
      width: '352px',
      maxWidth: 'calc(100vw - 32px)',
      data: {
        profile: 'alexanderstreet',
        platform: 'proquest'
      }
    });
  }

  public hasProquest (): boolean {
    const product = this._products.filter((product) => {
      return product['profile']  === 'proquest';
    })[0];

    if (product) {
      return true;
    }
    return false;
  }

  public getProducts (): Object[] {
    return this._products;
  }

  filteredProducts(): any[] {
    return this.getProducts().filter(product =>
      product['profile']?.includes('radr') ||
      product['profile'] === 'glmu2' ||
      product['profile'] === 'avc'
    );
  }


  public hasAlexanderStreet (): boolean {
    const product = this._products.filter((product) => {
      return product['profile'] === 'alexanderstreet';
    })[0];

    if (product) {
      return true;
    }
    return false;
  }

  public get hasBothRadrAndRadr2(): boolean {
    const hasRadr = this._products.some(p => p['profile'] === 'radr');
    const hasRadr2 = this._products.some(p => p['profile'] === 'radr2');
    return hasRadr && hasRadr2;
  }
   // Check if any of the HWC non tile products exist in the allProducts array
   isNonCGTileMissing(allProducts: { profile: string }[]): boolean {
    return !allProducts.some(product => AppConfig.productsWithTiles.has(product.profile));
  }
}
